module.exports = __webpack_public_path__ + "static/media/pl-file-upload.80814525.svg";